import { defineStore } from 'pinia'
import type { ToastProps } from '@ui/models/feedback/Toast.model'

export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: [] as ({ id: string } & ToastProps)[],
  }),
  actions: {
    addToast(toast: ToastProps) {
      const id = `${this.toasts.length}-${Date.now()}`
      const newToast = { ...toast, id }
      this.toasts.push(newToast)
    },
    removeToast(id: string) {
      const index = this.toasts.findIndex(toast => toast.id === id)
      if (index !== -1) {
        this.toasts.splice(index, 1)
      }
    },
  },
})
